module.exports = __webpack_public_path__ + "static/media/logo.79dec79d.png";